import 'swiper/swiper-bundle.css';
import Swiper from 'swiper/bundle';
import Hash from '../../utils/hash';

export default class Carousel {
    constructor(parent, el) {
        this.parent = parent;
        this.el = el;
        this.init();
        this.centerlisedSlides();
        this.selectModelFromHash();
        window.addEventListener('hashchange', () => {
            this.selectModelFromHash();
        }, false);
    }

    init() {
        this.swiper = new Swiper(this.el, {
            navigation: {
                nextEl: '.carousel-control--next',
                prevEl: '.carousel-control--previous',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
                clickable: true,
            },
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: false,
            noSwipingSelector: 'a, [data-group-acc]',
            watchOverflow: true,
            isLocked: true,
            observer: true,
            breakpoints: {
                320: {
                    slidesPerView: 1.3,
                },
                480: {
                    slidesPerView: 1.3,
                    spaceBetween: 5,
                },
                768: {
                    slidesPerView: 'auto',
                },
            },
            on: {
                lock: () => this.el.classList.add('swiper-center'),
                unlock: () => this.el.classList.remove('swiper-center'),
            },
        });
    }

    update(index) {
        const slideIndex = index || 0;
        this.swiper.update();
        this.swiper.slideTo(slideIndex, 800);
    }

    centerlisedSlides() {
        const { slides } = this.swiper;
        const desktop = window.matchMedia('(min-width: 768px)');
        if (desktop.matches) {
            if (slides.length === 1) {
                this.swiper.wrapperEl.closest('.swiper-container').classList.add('swiper-bigger-slide');
            } else {
                this.swiper.wrapperEl.closest('.swiper-container').classList.remove('swiper-bigger-slide');
            }
        }
    }

    selectModelFromHash() {
        const model = Hash.get('model');
        if (model) {
            this.selectModel(model);
        }
    }

    selectModel(model) {
        const { slides } = this.swiper;

        slides.forEach((slide, index) => {
            this.swiper.slides[index].classList.remove('selected-model');

            if (slide.id === model) {
                this.swiper.slides[index].classList.add('selected-model');
                this.update(index);
            }
        });
    }
}
